module.exports = __webpack_public_path__ + "img/team-avatar.fb611705.svg";